// @flow
import i18n from "i18next";
import k from "src/i18n/keys";
import React from "react";
import { useSelector } from "react-redux";
import { HStack, Box, Spinner } from "@chakra-ui/react";
import Tooltip from "src/components/Tooltip";
import Icons from "src/icons";
import { getSelectedChecklist } from "src/reducers";
import { RemoveWrapper } from "../../styles";
import * as styles from "./styles";

type ActionsBarProps = {
  openFile: Function,
  fetchingFileUrl: boolean,
  fetchingEditUrl: boolean,
  disabled: boolean,
  fileSource: string,
  handleEditSharepointFile: Function,
  handleDownload: Function,
  openModal: Function
};

const ActionsBar = ({
  openFile,
  fetchingFileUrl,
  fetchingEditUrl,
  disabled,
  fileSource,
  handleEditSharepointFile,
  handleDownload,
  openModal
}: ActionsBarProps) => {
  const selectedChecklist = useSelector(({ app }) => getSelectedChecklist(app));
  return (
    <HStack {...styles.actionsBar}>
      <Tooltip title={i18n.t(k.OPEN)}>
        <Box sx={styles.iconBtn} onClick={openFile}>
          {fetchingFileUrl ? (
            <Spinner size="xs" color="unifize_inkLightest" />
          ) : (
            <Icons type="preview" />
          )}
        </Box>
      </Tooltip>

      {!disabled && fileSource === "microsoft365" && (
        <Tooltip title={i18n.t(k.EDIT1)}>
          <Box sx={styles.iconBtn} onClick={handleEditSharepointFile}>
            {fetchingEditUrl ? (
              <Spinner size="xs" color="unifize_inkLightest" />
            ) : (
              <Icons type="edit3" />
            )}
          </Box>
        </Tooltip>
      )}

      <Tooltip title={i18n.t(k.DOWNLOAD)}>
        <Box sx={styles.iconBtn} onClick={handleDownload}>
          <Icons type="download2" />
        </Box>
      </Tooltip>

      {!disabled && !selectedChecklist.isViewOnly && (
        <Tooltip
          title={i18n.t(k.DELETE)}
          sx={{
            backgroundColor: "red"
          }}
        >
          <RemoveWrapper data-cy="removeFileModalTrigger" onClick={openModal}>
            <Icons type="decrement" width="14" height="14" />
          </RemoveWrapper>
        </Tooltip>
      )}
    </HStack>
  );
};

export default ActionsBar;
